import{k as r}from"./chunk-P6M5SGWP.js";import{m as e}from"./chunk-HBP5N4FR.js";e();r();var i=t=>{switch(!0){case t.pendingResults:return"Pending (Smart Contract Execution)";case t.status==="reward-reverted":return"fail";default:return t.status.toString()}};export{i as a};
//# sourceMappingURL=chunk-MXDZDWRM.js.map
